/**
 * Utility functions for handling image URLs
 */

/**
 * Constructs a full image URL by combining the API base URL with a relative path
 * @param {string} path - The image path (relative or absolute)
 * @param {string} fallbackImage - Optional fallback image if path is not provided
 * @returns {string} The complete image URL
 */
export const getImageUrl = (path, fallbackImage = null) => {
  if (!path) return fallbackImage;
  
  // If path already starts with http/https, return as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // Otherwise, combine with API base URL
  const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
  return `${baseUrl}${path.startsWith('/') ? path : '/' + path}`;
};

/**
 * Handles image loading errors by setting a fallback image
 * @param {Event} e - The error event
 * @param {string} fallbackImage - The fallback image URL
 */
export const handleImageError = (e, fallbackImage) => {
  if (fallbackImage) {
    e.target.src = fallbackImage;
  }
};

export default {
  getImageUrl,
  handleImageError,
};
